var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD20MessagePoint = function SvgD20MessagePoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 1.029A7.971 7.971 0 1 0 9 16.97 7.971 7.971 0 0 0 9 1.03z",
    fill: "#FFBF00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFBF00",
    cx: 9,
    cy: 9,
    r: 6.686
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.074 13.2v-2.065H9.32c2.017 0 3.197-1.123 3.197-2.855 0-1.712-1.18-2.835-3.197-2.835H6.342v7.754h1.732zm1.17-3.597h-1.17V6.977h1.17c.961 0 1.541.447 1.541 1.303 0 .866-.58 1.323-1.541 1.323z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
};
export default SvgD20MessagePoint;